<template lang="pug">
    component(
        v-bind="linkProps.props"
        v-on="linkProps.events"
    )
        slot
</template>

<script>
export default {
    props: {
        to: {
            type: [String, Object],
            default() {
                return {}
            },
        },
    },
    computed: {
        path() {
            return typeof this.to === 'object' ? this.to.path : this.to
        },
        linkProps() {
            const props = {
                is: 'nuxt-link',
                to: this.to,
            }

            const events = {}

            if (this.path) {
                if (this.path.startsWith('#')) {
                    props.is = 'div'
                    delete props.to

                    events.click = () => {
                        this.$scrollTo(this.path)
                    }
                } else if (this.path.startsWith('http')) {
                    props.is = 'a'
                    props.href = this.path
                    props.target = '_blank'
                    props.rel = 'noopener'
                    delete props.to
                } else if (this.path.startsWith('tel')) {
                    props.is = 'a'
                    props.href = this.path
                    delete props.to
                }
            }

            return {
                props,
                events,
            }
        },
    },
    mounted() {
        // Only run invoca phone change if we have a tel and invoca is enabled
        if (this.path && this.path.startsWith('tel') && this.$invoca.enabled)
            this.$invoca.changePhone()
    },
}
</script>
